import PurchaseMethods from './PurchaseMethods'

export default PurchaseMethods
